"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeatureToggle = void 0;
var _react = require("react");
var _hooks = require("../hooks");
/**
 *
 * @param feature Feature to toggle.
 * @param children Children
 * @param additionalCondition Optional condition to check for to to render **On** switch.
 * @returns
 */
const FeatureToggle = ({
  children,
  feature,
  additionalCondition
}) => {
  const {
    isFeatureEnabled
  } = (0, _hooks.useFeatureToggles)();

  // if additional condition was provided, then the rendering of the On switch depends also on this, condition and not just turned on feature toggle.
  const isEnabled = isFeatureEnabled(feature) && (additionalCondition ?? true);
  const toggledChildren = _react.Children.map(children, child => /*#__PURE__*/(0, _react.cloneElement)(child, {
    isEnabled
  }));
  return toggledChildren;
};
exports.FeatureToggle = FeatureToggle;
